<template>
  <v-container class="px-8 py-5">
    <v-row class="body-2 font-weight-light justify-space-between">
      <div>
        <v-breadcrumbs class="breadcrumbs pa-0" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <span>{{$todayDate()}}</span>
    </v-row>
    <v-row class="justify-center pt-6">

      <v-col v-if="schoolPlan.id" cols="12" md="7" class="pa-0 mr-0 mr-md-10">
        <v-row class="mb-4">
          <v-col cols="12" class="pa-0">
            <v-card
              outlined
              class="pa-4"
            >
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="8" class="text-h6">Osnovni podaci</v-col>
              </v-row>
              <v-row>
                <v-col class="text-right font-weight-light">Naziv nastavnog plana:</v-col>
                <v-col cols="8">{{ schoolPlan.title }}</v-col>
              </v-row>
              <v-row>
                <v-col class="text-right font-weight-light">Razred:</v-col>
                <v-col cols="8">{{ (+schoolPlan.school_class > 10) ? `${+schoolPlan.school_class - 10}. razred (Srednja škola)` : `${schoolPlan.school_class}. razred` }}</v-col>
              </v-row>
              <v-row>
                <v-col class="text-right font-weight-light">Smjer:</v-col>
                <v-col cols="8">{{joinedEduFields}}</v-col>
              </v-row>
              <v-row>
                <v-col class="text-right font-weight-light">Škola:</v-col>
                <v-col cols="8">{{(schoolPlan.school) ? schoolPlan.school.name : '-'}}</v-col>
              </v-row>
              <v-row>
                <v-col class="text-right font-weight-light">Županija:</v-col>
                <v-col cols="8">{{(schoolPlan.canton) ? schoolPlan.canton.title : '-'}}</v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="$checkPermission('reorder subjects') && subjectGroups.length > 0">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
                height="44"
                class="text-none"
                color="primary"
                depressed
                text
                @click="reorderDialog = true"
            >
                Promijeni redoslijed
            </v-btn>
          </v-col>
        </v-row>
        
        <v-row v-if="subjectGroups.length > 0" class="justify-center">
          <v-expansion-panels accordion>
            <v-expansion-panel
              v-for="group in subjectGroups"
              :key="group.id"
              @click="addedSubjects = []"
            >
              <v-expansion-panel-header hide-actions>
                <v-row>
                  <v-col>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="mb-2">
                          <span class="font-weight-light">Naziv grupe: </span>
                          <span>{{ group.title }}</span>
                        </v-list-item-title>
                        <v-list-item-title>
                          <span class="font-weight-light">Izborna grupa: </span>
                          <span>{{ (group.optional === 1) ? 'Da' : 'Ne' }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col>
                    <div class="d-flex align-center justify-end" style="height: 100%">
                      <span class="font-weight-light">Broj predmeta: </span>
                      <span>{{(group.subjects) ? group.subjects.length : 0}}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content style="background-color: rgba(240, 245, 247, 0.5);" class="py-4">
                <v-row>
                  <v-col class="text-h6">Predmeti</v-col>
                </v-row>
                <v-row v-for="subject in group.subjects" :key="subject.id">
                  <v-col>
                    <span class="font-weight-light">Naziv predmeta:</span> {{ subject.title }}
                  </v-col>
                  <v-col class="text-right">
                    <span class="font-weight-light">Broj sati tjedno:</span> 
                    {{subject.pivot.weekly_classes}} {{subject.pivot.weekly_classes_practice ? `+ (${+subject.pivot.weekly_classes_practice})` : '' }}
                  </v-col>
                </v-row>
                <v-row v-for="(subject, index) in addedSubjects" :key="subject.d">
                  <v-col cols="6">
                    <v-row>
                      <v-subheader style="height: auto;">Naziv predmeta: </v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-autocomplete
                          :items="filteredSubjects"
                          placeholder="Odaberite predmet"
                          item-text="title"
                          item-value="id"
                          v-model="subject.id"
                          height="44"
                          dense
                          hide-details
                          outlined
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-subheader style="height: auto;">Sati: </v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-text-field
                          outlined
                          hide-details
                          height="44"
                          step="0.5"
                          dense
                          type="number"
                          v-model="subject.classes"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-subheader style="height: auto;">Praksa: </v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-text-field
                          outlined
                          hide-details
                          height="44"
                          step="0.5"
                          dense
                          type="number"
                          v-model="subject.practice"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2" class="d-flex align-end">
                    <v-row class="align-end">
                      <v-col class="pb-0">
                        <v-btn
                          height="44"
                          style="min-width: 44px; width: 44px;"
                          class="red darken-2 elevation-0"
                          @click="deleteAdded(index)"
                        >
                          <v-icon color="white">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-1"><v-divider></v-divider></v-col>
                </v-row>
                <v-row v-if="$checkPermission('school_plans create')">
                  <v-btn  
                    class="elevation-0 primary--text"
                    text
                    @click="addSubject(group.subjects)"
                  > + Dodaj polje</v-btn>
                </v-row>
                <v-row v-if="addedSubjects.length > 0 && $checkPermission('school_plans create')" class="flex-column">
                  <v-col>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col>
                    <v-btn 
                      block height="44" 
                      class="primary elevation-0"
                      @click="addGroupSubjects(group)"
                    >Dodaj predmete</v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-col>

      <v-col 
        cols="12" 
        md="3"
        class="pa-0"
        v-if="$checkPermission('school_plans edit') && $checkPermission('school_plans create') && $checkPermission('school_plans delete')"
      >
        <v-btn
          block
          height="44"
          v-if="$checkPermission('school_plans edit')"
          class="primary elevation-0 mb-4"
          @click="$router.push(`/admin/nastavni_planovi/${schoolPlan.id}/uređivanje`)"
        >
          Uredi podatake
        </v-btn>
        <v-btn
          block
          height="44"
          depressed
          v-if="$checkPermission('school_plans create')"
          class="primary mb-4"
          @click="addDialog = true"
        >
          Dodaj grupu
        </v-btn>
        <v-btn
          block
          height="44"
          outlined
          depressed
          v-if="$checkPermission('school_plans delete')"
          @click="deleteDialog = true"
        >
          Obriši nastavni plan
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="reorderDialog"
            @click:outside="reorderDialog = false"
    >
        <v-card>
            <v-toolbar color="primary" dark>
                <v-btn @click.native="reorderDialog = false" dark icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Promijeni redoslijed</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn @click.native="reorderSubjects" color="primary" depressed large>Spremi</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-container>
                <v-row justify="center">
                    <v-col cols="12" sm="8" class="px-0">
                        <v-alert type="info" color="blue darken-1">
                            Redoslijed predmeta utječe na ispis predmeta na izvještajima/svjedodžbama.
                        </v-alert>
                    </v-col>
                    <v-col cols="10" sm="8">
                        <draggable
                            v-bind="dragOptions"
                            :list="allSubjects"
                            @start="dragging = true"
                            @end="dragging = false"
                        >
                            <transition-group type="transition" :name="!dragging ? 'flip-list' : null">
                              <v-row
                                v-for="(subject, index) in allSubjects"
                                :key="subject.id"
                              >
                                <v-col class="subject-list-item d-flex shrink align-center px-3 mb-1 mr-2">
                                    {{ index + 1 }}.
                                </v-col>  
                                <v-col class="subject-list-item d-flex grow align-center py-3 pl-3 mb-1">
                                    {{ subject.title }}
                                </v-col>
                              </v-row>
                            </transition-group>
                        </draggable>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>

    <v-dialog
      v-model="addDialog"
      width="500"
      @click:outside="closeDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
            <v-toolbar-title>Dodajte grupu</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn @click.native="closeDialog" dark icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-row>
              <v-col cols="4">
                <v-subheader class="justify-end">Naziv grupe: </v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  outlined
                  hide-details
                  dense
                  height="44"
                  v-model="subjectGroupTitle"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-subheader class="justify-end">Izborna grupa: </v-subheader>
              </v-col>
              <v-col cols="8">
                <div class="d-flex align-center" style="height: 100%">
                  <v-checkbox
                    dense
                    hide-details
                    v-model="optional"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            height="44" 
            depressed
            class="text-none"
            @click="closeDialog"
          >
            Odustani
          </v-btn>
          <v-btn 
            height="44"
            depressed
            class="primary text-none"
            @click="addSubjectGroup"
          >
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title
                primary-title>
            {{ dialogTitle }}
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
            {{ deleteText }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="deleteDialog = false" depressed large outlined>Odustani</v-btn>
            <v-btn @click="deleteSchoolPlan()" color="error" depressed large>Izbriši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {serverBus} from "../../main";
import draggable from 'vuedraggable'
import ApiV2 from '@/services/ApiV2'

export default {
  components: {
    draggable
  },
  data: () => ({
    schoolPlan: {},
    optional: false,
    subjectGroupTitle: '',
    subjects: [],
    subjectGroups: [],
    groupSubjects: [],
    addedSubjects: [],
    allGroupSubjects: [],
    educationalFields: [],
    addDialog: false,
    deleteDialog: false,
    reorderDialog: false,
    dragging: false,
    isOpen: false,
    deleteText: 'Operacija koju ste zatražili može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?',
    dialogTitle: 'Jeste li sigurni?'
  }),
  computed: {
    filteredSubjects() {
      if(this.allGroupSubjects) {
        let ids = this.allGroupSubjects.map(subject => subject.id);
        const currentlyAddedIds = this.groupSubjects.map(subject => subject.id)
        ids.push(...currentlyAddedIds)
        return this.subjects.filter(item => ids.indexOf(item.id) === -1);
      } else {
        return this.subjects;
      }
    },
    joinedEduFields(){
      return this.educationalFields.map(e => e.name).join(", ");
    },
    breadcrumbs() {
      return [
        {
          text: 'Nastavni planovi',
          disabled: false,
          exact: true,
          to: '/admin/nastavni_planovi',
        },
        {
          text: this.schoolPlan.title,
          disabled: true
        },
      ]
    },
    dragOptions() {
      return {
          animation: 200,
          disabled: false,
          ghostClass: "ghost"
      };
    },
    allSubjects() {
      if(this.subjectGroups.length <= 0) {
        return;
      }

      let allSubjects = [];
      const subjectGroups = [...this.subjectGroups];

      subjectGroups.forEach((group) => {
        group.subjects.forEach((subject) => {
          allSubjects.push(subject);
        })
      });
      if (allSubjects[0]?.pivot.sequence == null)
        return allSubjects;

      return allSubjects.sort((a, b) => a.pivot.sequence > b.pivot.sequence ? 1 : -1)
    }
  },
  methods: {
    closeDialog () {
      this.addDialog = false
      this.subjectGroupTitle = ''
    },

    reorderSubjects() {
      const orderedSubjects = this.allSubjects.map((subject, index) => {
        let pivotId = subject.pivot.id;

        return {
          id: pivotId,
          sequence: index + 1
        }
      });

      ApiV2.post('subject_groups/order_subjects', orderedSubjects)
        .then(() => {
          this.getOnePlan();
          this.reorderDialog = false;
          serverBus.$emit('show-snackbar', true);
        }).catch(() => {
          serverBus.$emit('show-snackbar', false);
        })
    },

    getOnePlan() {
      ApiV2.get(`school_plans/${this.$route.params.id}`,
      {params: {with: ["subjectGroups.subjects" , "educationalFields", "school", "canton"]}})
        .then(response => {
          this.schoolPlan = response.data;
          this.subjectGroups = response.data.subject_groups;
          this.educationalFields = response.data.educational_fields;

          this.subjectGroups.forEach(group => {
            group.subjects.forEach(subject => {
              this.allGroupSubjects.push(subject)
            })
          })
        });
    },
    getSubjects() {
      this.$axios.get('/v2/subjects', {
          params: {
            perPage: -1
          }
        })
        .then(response => {
          this.subjects = response.data.data;
        });
    },
    addSubject(groupSubjects) {
      this.groupSubjects = groupSubjects;
      this.addedSubjects.push({id: null, classes: 0, practice: 0});
    },
    deleteAdded(index) {
      this.addedSubjects.splice(index, 1);
    },
    addGroupSubjects(group){
      let dataObject = {};

      this.addedSubjects.forEach(item => {
        Object.assign(dataObject, {[item.id]: {weekly_classes: parseFloat(item.classes).toFixed(2), weekly_classes_practice: parseFloat(item.practice).toFixed(2) }})
      });

      this.$axios.post(`/v2/subject_groups/${group.id}/subjects`, {
        data: dataObject,
        method: "syncWithoutDetaching"
      }).then(response => {
          this.addedSubjects = [];
          group.subjects = response.data.subjects;
          this.groupSubjects = response.data.subjects;
          serverBus.$emit('show-snackbar', true, `Uspješno ste dodali predmet/e u grupu "${group.title}"`);
        })
        .catch((error) => {
          if (error.response.status == 422) {
            for (let key in error.response.data.errors) {
              serverBus.$emit('show-snackbar', false, error.response.data.errors[key][0]);
            }
          } else {
            serverBus.$emit('show-snackbar', false);
          }
        });
    },
    addSubjectGroup() {
      this.$axios.post(`/v2/subject_groups`, {
          school_plan_id: this.schoolPlan.id,
          title: this.subjectGroupTitle,
          optional: this.optional
      }).then(() => {
          this.$refs.form.reset();
          this.addDialog = false;
          this.getOnePlan();
          serverBus.$emit('show-snackbar', true, `Uspješno ste dodali grupu u nastavni plan "${this.schoolPlan.title}".`);
        })
        .catch((error) => {
          if (error.response.status == 422) {
            for (let key in error.response.data.errors) {
                serverBus.$emit('show-snackbar', false, error.response.data.errors[key][0]);
            }
          } else {
            serverBus.$emit('show-snackbar', false);
          }
        });
    },
    deleteSchoolPlan() {
      this.$axios.delete(`/v2/school_plans/${this.schoolPlan.id}`)
        .then(() => {
          this.deleteDialog = false;
          serverBus.$emit('show-snackbar', true, 'Uspješno se izbrisali nastavni plan.');
          this.$router.push('/admin/nastavni_planovi');
        })
        .catch((error) => {
          serverBus.$emit('show-snackbar', false, error.response.data);
        });
    }
  },
  mounted() {
    this.getOnePlan();
    this.getSubjects();
  }
};
</script>

<style>
  .breadcrumbs .v-breadcrumbs__item {
    font-weight: 500 !important;
  }

  .breadcrumbs .v-breadcrumbs__item--disabled {
    font-weight: 300 !important;
  }

  .v-expansion-panel::before {
    box-shadow: none !important;
  }

  .v-expansion-panels {
    border: thin solid rgba(0, 0, 0, 0.12)
  }

  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }

  .ghost {
    opacity: 0.4;
  }

  .subject-list-item {
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    background-color: #f3f3f3;
    cursor: move;
  }

  .rotated-icon {
    transform: rotate(-90deg);
  }
</style>
